<template>
    <CContainer style="position:absolute;overflow:hidden;top:0;bottom:0;left:0;right:0;max-width:1024px;" class="flex border-dark border-end border-start px-5">
        <router-view />
    </CContainer>
</template>
